{
  "zh-TW": {
    "baseChip": {
      "states": {
        "included": "已包含",
        "excluded": "已排除"
      }
    }
  }
}
